<template>
  <div class="asd20-text-avatar" :style="`--bg: ${color}`">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'Asd20TextAvatar',
  props: {
    text: { type: String, default: '' },
    color: { type: String, default: '#162B68' },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-text-avatar {
  width: space(2);
  height: space(2);
  overflow: hidden;
  background: var(--bg);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--website-typography__font-family-headlines);
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1;
  border-radius: 50%;
}
</style>
